module.exports = __webpack_public_path__ + "img/car.1250271c.png";